import '@shared/scss/all.scss';
import { createApp } from 'vue';
import vuetify from '@ganaderia/vuetify';
import Main from '@ganaderia/Main.vue';
import router from './router';
import { client } from '@shared/openapi/ganaderia-api';

const BASE_URL_API = (import.meta as any).env.VITE_GANADERIA_API_URL;
client.setConfig({ baseURL: BASE_URL_API });

const app = createApp(Main);
app.use(router);
app.use(vuetify);

router.isReady().then(() => app.mount('#app'));
